<template>
  <div>
    <v-container>
      <v-text-field label="Title" v-model="sheet.name"></v-text-field>

      <v-text-field label="縦軸/上 top" v-model="sheet.top"></v-text-field>
      <v-text-field label="縦軸/下 bottom" v-model="sheet.bottom"></v-text-field>
      <v-text-field label="横軸/左 left" v-model="sheet.left"></v-text-field>
      <v-text-field label="横軸/右 right" v-model="sheet.right"></v-text-field>

      <div
        class="d-flex align-start flex-wrap pb-12"
      >
        <div class="mb-8">
          <v-switch
            class="my-0"
            v-model="sheet.markIsName"
            label="Name-Mark"
          ></v-switch>
          <div style="margin-top: -15px;">
            <svg width="106" height="106" viewBox="0 0 200 200"><use xlink:href="#path"></use><circle cx="100" cy="100" r="75" fill="#FFFFFF" fill-opacity="0.25" stroke="gray"></circle><text fill="black" font-family="sans-serif" font-size="30"><textPath xlink:href="#path" startOffset="0%" method="stretch">{{ sheet.markIsName ? 'Mark' : 'Name' }}</textPath></text><text x="100" y="115" font-size="40" font-family="sans-serif" text-anchor="middle" alignment-baseline="auto" fill="black">{{ !sheet.markIsName ? 'Mark' : 'Name' }}</text><circle cx="100" cy="100" r="96" fill="rgb(255,255,0)" fill-opacity="0" stroke="none" stroke-width="2"></circle></svg>
          </div>
        </div>
        <div>
          <v-switch
            class="my-0"
            label="Note表示(PCのみ)"
            v-model="viewNote"
          ></v-switch>
        </div>
      </div>
    </v-container>

    <v-footer
      color="pink lighten-5"
      absolute
    >
      <v-container
        text-center
      >
        <v-btn
          color="red"
          dark
          depressed
          @click.stop="deleteDialog = true"
        >
          {{ $t('Workspace.setting.deleteButton') }}
        </v-btn>
      </v-container>
    </v-footer>

    <DeleteDialog :sheet="sheet" :delete-dialog="deleteDialog" @close-diagram="deleteDialog = false"></DeleteDialog>
  </div>
</template>

<script>
import master from '@/json/master.json'
import DeleteDialog from '@/components/DeleteDialog'

export default {
  props: ['sheet'],
  components: {
    DeleteDialog
  },
  data () {
    return {
      master: master,
      deleteDialog: false,
      viewNote: localStorage.getItem('viewNote') ? 1 : '' // localStorageは、true/falseは文字列で格納されてしまう。
    }
  },
  updated () {
    localStorage.setItem('viewNote', this.viewNote ? 1 : '') // localStorageは、true/falseは文字列で格納されてしまう。
  }
}
</script>
